import { render, staticRenderFns } from "./expert_info.vue?vue&type=template&id=449e27a9&scoped=true&"
import script from "./expert_info.vue?vue&type=script&lang=ts&"
export * from "./expert_info.vue?vue&type=script&lang=ts&"
import style0 from "./expert_info.vue?vue&type=style&index=0&id=449e27a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449e27a9",
  null
  
)

export default component.exports